import React from "react";
import {
  FieldWrapper,
  FilterSortGroup,
} from "./jobsFilterUtils";

export const MESSAGES_SORT_OPTIONS = [
  { value: "name", label: "Name" },
];

export function AdminMessagesFilterFields({
  focusedFieldId,
  onFocusClear,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="admin-messages-sort"
          sortBy={sortField}
          sortOrder={sortOrder}
          onSortByChange={setSortField}
          onSortOrderChange={setSortOrder}
          sortOptions={MESSAGES_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAdminMessagesFilterChips({
  sortOrder,
}) {
  const chips = [];
  if (sortOrder !== "desc") {
    chips.push({
      id: "sortOrder",
      key: "sortOrder",
      fieldId: "sort",
      label: `Direction: ${sortOrder === "asc" ? "Ascending" : "Descending"}`,
    });
  }
  return chips;
}
